export const moneyFormatter = new Intl.NumberFormat(undefined, {
	style: "currency",
	currency: "USD",
	maximumFractionDigits: 0,
	minimumFractionDigits: 0,
});

export const numberFormatter = new Intl.NumberFormat(undefined, {
	style: "decimal",
	maximumFractionDigits: 0,
	minimumFractionDigits: 0,
});
